export default __webpack_public_path__ + "static/FuturaBT-Medium-05d6a32587dae9b61d20afc9a810a940.ttf";